<template>
  <div
      class="user-info"
      @click="toggleProfileMenu"
      :class="{ 'open-reg-steps': profileMenu, 'user-info--no-cursor': isAppLocked}"
      ref="userInfo"
      v-click-outside-user="onClickOutsideUserInfo"
  >
    <p :title="displayUserName">{{ shrinkFirstName }} {{ shrinkLastName }}</p>
    <div class="online-marker-wrapper">
      {{ $lang.messages.online }}
      <span class="online-marker"></span>
    </div>
    <img src='@/assets/images/arrow_down.png' />

    <div class="infos-tooltip profile-info-tooltip" :class="{ 'profile-info-tooltip-visible': profileMenu }">
      <div class="type-one" v-if="!preferences">
        <router-link :to="{ name: 'UserProfile' }">
          {{ $lang.messages.userProfile }}
          <img src='@/assets/images/arrow_right.png' />
        </router-link>
      </div>
      <div class="type-one" v-if="!preferences">
        <router-link :to="{ name: 'FamilyProfile' }">
          {{ $lang.messages.familyProfile }}
          <img src='@/assets/images/arrow_right.png' />
        </router-link>
      </div>
      <div class="type-one" v-if="!preferences" :class="{'app--locked': childAdded === 'unfinished' || childAdded === 'current'}">
        <router-link :to="{ name: 'PaymentMethods' }">
          {{ $lang.messages.paymentMethods }}
          <img src='@/assets/images/arrow_right.png' />
        </router-link>
      </div>
      <div class="type-one logout-link" @click.prevent="logout">
        <span>
          {{ $lang.messages.logout }}
        </span>
      </div>
      <hr v-if="!preferences">
      <div class="type-two" v-if="!preferences">
        <div>
          <div class="online-marker"></div>
          <p>{{ $lang.messages.online }}</p>
          <img src='@/assets/images/checkmark_large.png' />
        </div>
      </div>
      <div class="type-two" v-if="!preferences">
        <div>
          <div class="invisible-marker"></div>
          <p>{{ $lang.messages.invisible }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import { LOGOUT } from "@/store/action.types";
  import vClickOutside from 'v-click-outside';
  import { API_ENV_NAME } from '@/common/config';

  export default {
    name: "UserMenu",
    directives: {
      ClickOutsideUser: vClickOutside.directive
    },
    props: {
      preferences: {
        type: Boolean,
        required: false,
        default: () => false
      }
    },
    data() {
      return {
        profileMenu: false
      }
    },
    computed: {
      ...mapGetters(["user", 'isAppLocked', "childAdded"]),
      displayUserName() {
        return this.user.firstname + ' ' + this.user.lastname
      },
      shrinkFirstName() {
        if (this.user.firstname) {
          let firstnameTemp = this.user.firstname;
          if (firstnameTemp.length > 16) {
            firstnameTemp =  firstnameTemp.substr(0, 1) + '.'
          }
          return firstnameTemp
        }
        return ''
      },
      shrinkLastName() {
        if (this.user.lastname) {
          let lastnameTemp = this.user.lastname;
          if (lastnameTemp.length > 16) {
            lastnameTemp =lastnameTemp.substr(0, 1) + '.'
          }
          return lastnameTemp;
        }
        return ''
      },
    },
    methods: {
      ...mapActions({
        logoutAction: LOGOUT,
      }),
      toggleProfileMenu() {
        this.profileMenu = !this.profileMenu
        this.$emit("toggleProfileMenu");
      },
      onClickOutsideUserInfo() {
        this.profileMenu = false
      },
      /**
       * @description Method sends request to API to do logout. if request is successful, we switch user to Login page.
       **/
      logout() {
        this.logoutAction().then(() => {
          if (API_ENV_NAME === 'demo') {
            this.$router.push({ name: "Demo" });
          }
          this.$router.push({ name: "Login" });
        });
      },
    }
  }
</script>

<style lang="scss">
  @import '@/scss/04_components/_user-info-menu.scss';
</style>
